import * as React from 'react';

import {CheckIcon, TimesIcon, ErrorTriangleIcon} from 'shells/icon';

import styles from './action-icon.module.css';

export const SuccessIcon = () => {
    return (
        <div className={styles['success-icon']}>
            <CheckIcon size={36} />
        </div>
    );
};

export const ErrorIcon = () => {
    return (
        <div className={styles['error-icon']}>
            <TimesIcon size={36} />
        </div>
    );
};

export const WarningIcon = () => {
    return (
        <div className={styles['warning-icon']}>
            <ErrorTriangleIcon size={36} />
        </div>
    );
};
